"use strict";

import BaseModel from "dias/core/models/baseModel";

class Foerderantragorganisation extends BaseModel {
  constructor() {
    super("foerderantragorganisationen");
  }
}

export default Foerderantragorganisation;
